var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService09(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222 222",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 222 222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.5,109h-25.717l-11.202-36.924H49.308L38.106,109H11.5v35h15.987l-3.663,12.073v51.203H38.5V222h40v-14.724h66V222h40   v-14.724h14.564v-51.203L195.402,144H210.5V109z M68.051,89.424h86.788l14.065,50.492H53.985L68.051,89.424z M83.5,180h-36v-18h36   V180z M175.5,180h-35v-18h35V180z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.5,45 173.5,45 173.5,15 95.5,15 95.5,0 50.5,0 50.5,22.077 58.57,28.104 50.5,33.572 50.5,41.552    57.438,45.614 50.5,49.837 50.5,60 95.5,60  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService09);
export default __webpack_public_path__ + "static/media/service_09.19b01bdc619a27b32b04d7c22166a8e9.svg";
export { ForwardRef as ReactComponent };